/**
 * Utilitários para manipulação de dados de scraping
 */

/**
 * Calcula há quantos dias foi feito o último scraping
 * @param {string | null} date - Data em formato ISO 8601
 * @returns {number} Número de dias desde a data (Infinity se null)
 */
export function daysSince(date) {
  if (!date) return Infinity;
  const diff = Date.now() - new Date(date).getTime();
  return Math.floor(diff / (1000 * 60 * 60 * 24));
}

/**
 * Retorna a cor do badge baseado no status de scraping
 * @param {boolean | null} is_scraping_completo
 * @returns {string} Cor do Material-UI
 */
export function getStatusColor(is_scraping_completo) {
  if (is_scraping_completo === null) return 'info';
  return is_scraping_completo ? 'success' : 'warning';
}

/**
 * Retorna ícone baseado na fonte dos dados
 * @param {string | null} fonte_scraping
 * @returns {string} Emoji ou caractere
 */
export function getSourceIcon(fonte_scraping) {
  switch (fonte_scraping) {
    case 'INPI': return '🌐';
    case 'PDF': return '📄';
    case 'RPI_XML': return '📰';
    default: return '❓';
  }
}

/**
 * Retorna o nome legível da fonte
 * @param {string | null} fonte_scraping
 * @returns {string}
 */
export function getSourceName(fonte_scraping) {
  switch (fonte_scraping) {
    case 'INPI': return 'INPI';
    case 'PDF': return 'PDF';
    case 'RPI_XML': return 'RPI XML';
    default: return 'Desconhecida';
  }
}

/**
 * Verifica se o processo precisa de atualização
 * @param {Object} processo
 * @returns {boolean}
 */
export function needsUpdate(processo) {
  if (!processo) return false;
  if (processo.is_scraping_completo === false) return true;
  if (!processo.data_ultimo_scraping) return true;
  return daysSince(processo.data_ultimo_scraping) > 30;
}

/**
 * Formata a mensagem de status do scraping
 * @param {Object} processo
 * @returns {string}
 */
export function getStatusMessage(processo) {
  if (!processo) return 'Informação não disponível';
  
  if (processo.is_scraping_completo === null) {
    return `Criado via ${processo.fonte_scraping || 'upload manual'}`;
  }
  
  if (processo.is_scraping_completo) {
    const dias = daysSince(processo.data_ultimo_scraping);
    if (dias === 0) return 'Atualizado hoje';
    if (dias === 1) return 'Atualizado há 1 dia';
    if (dias === Infinity) return 'Dados completos';
    return `Atualizado há ${dias} dias`;
  }
  
  return 'Aguardando sincronização com INPI';
}

/**
 * Retorna texto curto para o badge de status
 * @param {boolean | null} is_scraping_completo
 * @param {string | null} fonte_scraping
 * @returns {string}
 */
export function getStatusBadgeText(is_scraping_completo, fonte_scraping) {
  if (is_scraping_completo === null) {
    return fonte_scraping ? `Via ${fonte_scraping}` : 'Manual';
  }
  return is_scraping_completo ? 'Completo' : 'Incompleto';
}

/**
 * Formata data para exibição em português
 * @param {string | null} date
 * @returns {string}
 */
export function formatScrapingDate(date) {
  if (!date) return 'Nunca atualizado';
  
  try {
    const d = new Date(date);
    return d.toLocaleString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  } catch (error) {
    return 'Data inválida';
  }
}
